<template>
  <div>
    <div class="table_description table_description_filter">
      <div class="tertiary_color text_left">
        <div>{{ $t("trackPay.contracts.tip1") }}</div>
        <div>{{ $t("trackPay.contracts.tip2") }}</div>
        <div>{{ $t("trackPay.contracts.tip3") }}</div>
      </div>
    </div>
    <div class="table_head table_head_filter">
      <div class="flex flex_between">
        <div>
          <md-button class="md-blank" @click="showContractsEditModal({})">
            <i class="fa fa-plus"></i>
            {{ $t("trackPay.contracts.addNewContract") }}
          </md-button>
        </div>
      </div>
    </div>
    <div class="flex filter_table">
      <div class="flex flex_column w_100">
		  <AgItem :columnDefs="columnDefs"
				  :rowData="rowData"
				  v-on:sortChanged="sortChanged"
		  ></AgItem>
        <Pagination
          :totalNum="totalNum"
          :pageSize="pageSize"
          :sizeChange="sizeChange"
          :currentChange="currentChange"
          :currentPage="page"
        ></Pagination>
      </div>
      <!-- <DebtorOverviewFilter @apply-filter="applyFilter" /> -->
    </div>
    <ContractsEditModal ref="relationModal" @success="getList"></ContractsEditModal>
    <TrackProgressModal ref="TrackProgressModal" @change="getList"></TrackProgressModal>
  </div>
</template>

<script>
import AgItem from "src/components/templates/agGrid/AgItem.vue";
import Pagination from "src/components/templates/common/Pagination.vue";
import PaginationParent from "src/components/templates/common/PaginationParent.vue";
import {trackPayApi} from "src/common/api/trackPayApi";
import ContractsEditModal from "@/components/templates/trackPay/ContractsEditModal";
import {asDecimal, asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import CompanyTem from "@/components/templates/agGrid/CompanyTem";
import TrackProgressModal from "@/components/templates/trackPay/TrackProgressModal";

export default {
  extends: PaginationParent,
  components: {
    AgItem,
    Pagination,
    ContractsEditModal,
    CompanyTem,
    TrackProgressModal
  },
  data() {
    return {
      rowData: null,
      columnDefs: [],
      gridApi: null,
      filters: [],
      sorting: [],
    };
  },
  beforeMount() {
    this.setColumnDefs();
    this.getList();
  },
  methods: {
    sortChanged(sortData) {
      this.sorting = sortData;
      this.initPage();
      this.getList();
    },
    getGridApi(gApi) {
      this.gridApi = gApi;
    },
    setColumnDefs() {
      this.columnDefs = [
        {
          headerName: this.$t("trackPay.contractsTable.customer"),
          children: [
            {
              headerName: this.$t("common.label.name"),
              field: "debtorName",
              minWidth: 300,
              sortable: true,
              nameType: "debtorName",
              idType: "debtorId",
              cellRendererFramework: "CompanyTem"
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsTable.contract"),
          children: [
            {
              headerName: this.$t("trackPay.id"),
              field: "uuid",
              minWidth: 150,
              sortable: true
            },
            {
              headerName: this.$t("common.orderNumber"),
              field: "invoiceNumber",
              sortable: true,
              minWidth: 200
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsTable.dispatchAddress"),
          children: [
            {
              headerName: this.$t("common.country"),
              field: "fromCountry",
              sortable: true,
              minWidth: 100
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsEditModal.delivery"),
          children: [
            {
              headerName: this.$t("trackPay.contractsEditModal.latitude"),
              field: "latitude",
              sortable: true,
              minWidth: 130,
              valueFormatter:
                  asDecimal({
                    showZeroAsNotAvailable: true,
                    showEmptyAsNotAvailable: true,
                    decimals: 10})
            },
            {
              headerName: this.$t("trackPay.contractsEditModal.longitude"),
              field: "longitude",
              sortable: true,
              minWidth: 130,
              valueFormatter:
                  asDecimal({
                    showZeroAsNotAvailable: true,
                    showEmptyAsNotAvailable: true,
                    decimals: 10})
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsTable.shipment"),
          children: [
            {
              headerName: this.$t("common.amount"),
              field: "amount",
              sortable: true,
              minWidth: 130,
              valueFormatter: asMoneyAmount()
            },
            {
              headerName: this.$t("common.ccy"),
              field: "currency",
              minWidth: 80,
              sortable: true
            },
            {
              headerName: this.$t("trackPay.contractsTable.shipDate"),
              field: "invoiceDate",
              valueFormatter: asLocalizedDate(),
              minWidth: 120,
              sortable: true
            }
          ]
        },
        {
          headerName: this.$t("common.progress"),
          headerClass: "bg_special",
		  maxWidth: 500,
          children: [
	        {
		      headerName: this.$t("trackPay.contractsTable.currentState"),
		      cellRendererFramework: "ShipmentProgressStatus",
		      cellRendererParams: {
				companyType: "supplier"
		      },
		      minWidth: 210,
		      maxWidth: 210,
		      pinned: "right"
	        },
            {
              headerName: this.$t("trackPay.table.scheduled"),
              minWidth: 200,
              cellRendererFramework: "ContractStatusScheduled",
              cellRendererParams: {
                companyType: "supplier"
              },
              pinned: "right"
            },
            {
              headerName: this.$t("common.actions"),
              cellRendererFramework: "TrackAction",
              cellRendererParams: {
                showDetail: this.showDetail,
                delContract: this.delContract,
                showTrackingDetail: this.showTrackingDetail
              },
              minWidth: 90,
			  maxWidth: 110,
              pinned: "right"
            }
          ],
          pinned: "right"
        }
      ];
    },
    delContract(id) {
      trackPayApi.seller.deleteContract(id)
          .then(() => {
            this.getList();
          });
    },
    getList() {
	    this.rowData = [];

	    let postData = {
		    columns: [],
		    filters: this.filters || [],
		    maxResults: 25000,
		    offset: 0,
		    sorting: this.sorting
	    };

	    trackPayApi.seller.getCurrentContracts(postData)
		    .then((res) => {
			    this.rowData = res.data;
		    })
		    .catch(this.toast);
    },
    applyFilter(filters) {
      this.filters = filters;
      this.getList();
    },
    showDetail(data) {
      this.$refs.relationModal.showDetail(data);
    },
    showContractsEditModal(data) {
      this.$refs.relationModal.showRelationModal(data);
    },
    showTrackingDetail(data) {
      this.$refs.TrackProgressModal.showTrackingDetails(data);
    }
  }
};
</script>
<style lang="scss" scoped>
.table_description {
  min-height: 65px;
  margin: 20px 0;
  height: auto;
}
</style>
